import React from "react";

import { useCart } from "../../../provider/shopify/useCart";

import Link from "../../link";
import { Icon } from "../header";

type Props = {
  item: NonNullable<Queries.MenuRestFragment["items"]>[0];
  withTitle: boolean;
};

const Cart: React.FC<Props> = ({ item, withTitle }) => {
  const { totalItems, isLoading } = useCart();

  if (!item?.nav_link) return null;

  return (
    <Link
      link={item.nav_link}
      className="flex relative justify-start items-center w-5 h-5 text-xs font-normal border-b-0 lg:w-auto lg:h-auto base-transition-100 hover-focus:border-b-primary-600 hover-focus:text-primary-600 hover-focus:child-span:border-primary-600"
    >
      {!isLoading && totalItems > 0 && (
        <span className="flex absolute -top-0.5 justify-center items-center w-3 h-3 font-semibold text-center text-white rounded-full left-[10px] bg-primary-600 text-[8px]">
          {totalItems}
        </span>
      )}
      {item.nav_icon && <Icon name={item.nav_icon} />}
      <span className="border-b border-transparent lg:ml-1 base-transition-200">{withTitle && item.nav_title}</span>
    </Link>
  );
};

export default Cart;
